import React from "react";

function FullWrapper({ children }) {
  return <div className="w-full md:w-10/12 mx-auto h-full">{children}</div>;
}

export default FullWrapper;
